<template>
  <div class="nx-dashboard-shortcut__content">
    <v-btn class="v-btn"
           block
           flat
           :disabled="disabled"
           :href="url">
      <v-icon color="nx-neutral-200" medium>{{ icon }}</v-icon>
      <v-card-text>{{ text }}</v-card-text>
    </v-btn>
  </div>
</template>

<script>

export default {
  name: 'nx-dashboard-shortcuts-link',
  props: {
    icon: String,
    text: String,
    url: String,
    disabled: Boolean,
  },
};
</script>
